module.exports = __webpack_public_path__ + "img/photo_icon.f760ff2c.svg";